import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button, Box } from '@mui/material';
import { Download as DownloadIcon, Close as CloseIcon } from '@mui/icons-material';

const InstallPWA: React.FC = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<any>(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setPromptInstall(e);
      setSupportsPWA(true);
      
      // Mostrar banner después de 3 segundos
      setTimeout(() => {
        setShowInstallBanner(true);
      }, 3000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
    const { outcome } = await promptInstall.userChoice;
    if (outcome === 'accepted') {
      setShowInstallBanner(false);
    }
  };

  const handleCloseBanner = () => {
    setShowInstallBanner(false);
  };

  if (!supportsPWA) {
    return null;
  }

  return (
    <Snackbar
      open={showInstallBanner}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={null}
    >
      <Alert
        severity="info"
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              onClick={handleInstallClick}
              startIcon={<DownloadIcon />}
            >
              Instalar
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={handleCloseBanner}
              startIcon={<CloseIcon />}
            >
              Cerrar
            </Button>
          </Box>
        }
      >
        Instala Neos Contratos SDP en tu dispositivo para acceso rápido
      </Alert>
    </Snackbar>
  );
};

export default InstallPWA; 